import { get as _get } from "lodash";
// components
import { Box, ButtonBase, Typography, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TokenLogo from "../TokenLogo";

const copyTokenAddress = async (token) => {
  try {
    await navigator.clipboard.writeText(token.address);
  } catch (err) {
    console.log(err);
  }
};

const TokenInputPanel = ({ token, onSelect }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        pr: 1,
        borderRadius: "14px",
        bgcolor: "background.light",
        border: 1,
        borderColor: "transparent",
        "&:focus-within": { borderColor: "secondary.dark" },
      }}
    >
      <ButtonBase
        onClick={() => onSelect()}
        sx={{ flex: 1, minWidth: 0, justifyContent: "flex-start", gap: 1.5, p: 1.5, borderRadius: "14px" }}
      >
        {token ? (
          <>
            <TokenLogo token={token} size={32} />
            <Box sx={{ minWidth: 0, textAlign: "left" }}>
              <Typography sx={{ fontWeight: 600 }} noWrap>
                {_get(token, "symbol", "")}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
                {_get(token, "name", "")}
              </Typography>
            </Box>
          </>
        ) : (
          <Typography sx={{ fontWeight: 600, color: "primary.main", py: 0.75 }}>Select a token</Typography>
        )}
        <KeyboardArrowDownIcon fontSize="small" sx={{ ml: "auto", color: "text.secondary" }} />
      </ButtonBase>
      {token !== null && token.name !== "Koinos" ? (
        <Tooltip title="Copy token address">
          <IconButton aria-label="copy token address" size="small" onClick={() => copyTokenAddress(token)}>
            <ContentCopyIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      ) : null}
    </Box>
  );
};

export default TokenInputPanel;
